import marks from './marks';

export default function getMarks() {
	return [...marks];
}
